import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import {
  toggleMarkCompleteTransition,
  togglePublishedMarkCompleteTranstion,
  togglePublishedTeachLiveTransition,
  toggleTeachLiveTransition
} from "../../toggles/transitionalStates"
import {
  Context,
  LessonDetailsViewSchema,
  StudyPlanTargets,
  Transitions
} from "../../../types"
import {
  changeMicroSnapsCountTransition,
  downloadResourcesTransition,
  getLessonDetailsTransition
} from "./transitionalStates"

export const lessonDetailsDrawerState: StateNodeConfig<
  Context,
  LessonDetailsViewSchema,
  Transitions,
  BaseActionObject
> = {
  initial: "get_lesson_details_transition",
  states: {
    toggle_published_teach_live_transition: {
      ...togglePublishedTeachLiveTransition
    },
    toggle_teach_live_transition: { ...toggleTeachLiveTransition },
    toggle_mark_complete_transition: { ...toggleMarkCompleteTransition },
    toggle_published_mark_complete_transtion: {
      ...togglePublishedMarkCompleteTranstion
    },
    get_lesson_details_transition: { ...getLessonDetailsTransition },
    download_resources_transition: { ...downloadResourcesTransition },
    change_micro_snaps_count_transition: { ...changeMicroSnapsCountTransition },
    idle: {
      on: {
        DOWNLOAD_RESOURCES: {
          target: "download_resources_transition"
        },
        TEACH_LIVE: [
          {
            target: "toggle_teach_live_transition",
            cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.Edit
          },
          {
            target: "toggle_published_teach_live_transition",
            cond: (ctx, _evt) =>
              ctx.currentTarget === StudyPlanTargets.TeacherView
          }
        ],
        MARK_COMPLETE: [
          {
            target: "toggle_mark_complete_transition",
            cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.Edit
          },
          {
            target: "toggle_published_mark_complete_transtion",
            cond: (ctx, _evt) =>
              ctx.currentTarget === StudyPlanTargets.TeacherView
          }
        ],
        PREVIEW: {
          target: "#StudyPlan.get_lesson_preview_transition"
        },
        REMOVE_LESSON: {
          target: "#StudyPlan.remove_lesson_transition",
          actions: assign<Context>({
            lessonDetailViewModal: false,
            selectedLessonId: null,
            selectedSectionId: ctx =>
              ctx.addLessonModal ? ctx.selectedSectionId : null
          })
        },
        ADD_LESSON: {
          target: "#StudyPlan.add_lesson_transition"
        },
        REPLACE_LESSON: {
          target: "#StudyPlan.replace_lesson_transition"
        },
        CHANGE_MICROSNAPS_COUNT: {
          target: "change_micro_snaps_count_transition"
        }
      }
      // When whenever modal is closed, go to either "add_lesson" or "edit_plan" state.
    }
  },
  on: {
    BACK_TO_ADD_MASTERY_LESSON: {
      /* selectedLesson is still needed to return to add_lesson state */
      target: "add_lesson.idle",
      actions: assign<Context>({
        lessonDetailViewModal: false,
        lessonDetails: null,
        selectedLessonId: null
      })
    },
    CLOSE: [
      {
        target: "#StudyPlan.edit_plan.remove_section_transition",
        actions: assign((_ctx, _evt) => ({
          lessonDetailViewModal: false,
          lessonDetails: null,
          selectedLessonId: null,
          addLessonModal: false,
          lessonOptions: []
        })),
        cond: (ctx, _evt) => {
          const currentSection = ctx.studyPlan?.sections?.find(
            section => section.id === ctx.selectedSectionId
          )
          return (
            ctx.previousParentState === "edit_plan" &&
            currentSection &&
            !currentSection.items?.length
          )
        }
      },
      {
        target: "idle",
        actions: assign<Context>({
          selectedSectionId: null,
          lessonDetailViewModal: false,
          lessonDetails: null,
          selectedLessonId: null,
          addLessonModal: false
        })
      }
    ]
  },
  always: [
    {
      target: "add_lesson.idle",
      cond: ctx => ctx.addLessonModal && !ctx.lessonDetailViewModal
    },
    {
      target: "idle",
      cond: ctx => !ctx.addLessonModal && !ctx.lessonDetailViewModal
    }
  ]
  // When whenever modal is closed, go to either "add_lesson" or "edit_plan" state.
}
